export enum SESSION_KEYS {
    SUCCESSVALIDATION = '_SUCCESSVALIDATION',
    TIMERLOAD = '_TMLA_USER',
    UUID = '_UUID',
    SOCIO = '_SOCIO',
    ISLOGINCIAM = '_ISLOGINCIAM'
}

export enum PARAMETER_KEYS {
    SOCIO = 'app',
    JWT = 'signed'
}

export enum FORM_KEYS {
    CARD = 'cardNumber',
    DOCUMENT_NUMBER = 'documentNumber',
    DOCUMENT_TYPE = 'documentType',
    WEB_KEY = 'password',
    DNI = 'dni',
    CE = 'ce',
    PASS = 'passport'
}